import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { dbMapApi } from '../../../../../services/requests';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  onSuccess: () => void;
};

const CreateDbMapModal = ({ showModal, closeModal, onSuccess }: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [table, setTable] = useState('');
  const [column, setColumn] = useState('');
  const [reference, setReference] = useState('');

  const handleCreate = async () => {
    setIsLoading(true);

    const source = dbMapApi.axios.CancelToken.source();

    try {
      const res = await dbMapApi.store({ table, column, reference });

      if (res.status === HttpStatus.CREATED || res.status === HttpStatus.OK) {
        frontendNotification({
          message: t('successfullyCreated'),
          type: 'success',
        });

        closeModal();
        onSuccess();
      } else {
        throw res;
      }
    } catch (err) {
      if (!dbMapApi.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    } finally {
      setIsLoading(false);
    }

    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={t('createDbMap')}
      showModal={showModal}
      closeModal={closeModal}
      action={handleCreate}
      isLoading={isLoading}
    >
      <div className="form">
        <div className="form-row">
          <div className="form-row-item">
            <label htmlFor="dbMapTable">{t('table') as string}</label>
            <input
              id="dbMapTable"
              type="text"
              value={table}
              onChange={(e) => setTable(e.target.value)}
              disabled={isLoading}
            />
          </div>
          <div className="form-row-item">
            <label htmlFor="dbMapColumn">{t('column') as string}</label>
            <input
              id="dbMapColumn"
              type="text"
              value={column}
              onChange={(e) => setColumn(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <label htmlFor="dbMapReference">{t('reference') as string}</label>
            <input
              id="dbMapReference"
              type="text"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateDbMapModal;
